import React from 'react';
import arrowRight from '../../../../images/arrow-right-blue.svg';

const InfoCard = ({ cardContent }) => (
  <div className="autzu-fleets-info-card__container autzu-fleets-info-card__container--nyc">
    <img className="autzu-fleets-info-card__icon" alt="icon" src={cardContent.icon} />
    <h3 className="autzu-fleets-info-card__title">{cardContent.title}</h3>
    <p className="autzu-fleets-info-card__text">{cardContent.text}</p>
    {cardContent.link ? (
      <div className="autzu-fleets-info-card__link">
        <a className="section-1__link" href={cardContent.link.href}>
          {cardContent.link.text}
          <span>
            <img className="section-1__link__icon" src={arrowRight} alt="arrow" />
          </span>
        </a>
      </div>
    ) : null}
  </div>
);

export default InfoCard;



// WEBPACK FOOTER //
// ./src/components/Static/TorontoFleets/Shared/InfoCard.js